import type { HoursContent } from '@mawkaa/types';
import { Clock } from 'lucide-react';

interface HoursBlockProps {
  content: HoursContent;
  isEditing?: boolean;
}

const defaultDays = [
  { day: 'Lundi', dayAr: 'الاثنين', open: '09:00', close: '18:00', closed: false },
  { day: 'Mardi', dayAr: 'الثلاثاء', open: '09:00', close: '18:00', closed: false },
  { day: 'Mercredi', dayAr: 'الأربعاء', open: '09:00', close: '18:00', closed: false },
  { day: 'Jeudi', dayAr: 'الخميس', open: '09:00', close: '18:00', closed: false },
  { day: 'Vendredi', dayAr: 'الجمعة', open: '09:00', close: '18:00', closed: false },
  { day: 'Samedi', dayAr: 'السبت', open: '09:00', close: '13:00', closed: false },
  { day: 'Dimanche', dayAr: 'الأحد', open: '', close: '', closed: true },
];

export function HoursBlock({ content, isEditing }: HoursBlockProps) {
  const { title, schedule = defaultDays, note } = content;

  // Get current day (0 = Sunday, 1 = Monday, etc.)
  const today = new Date().getDay();
  const todayIndex = today === 0 ? 6 : today - 1; // Convert to Monday-first

  return (
    <section className="px-4 py-12">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <Clock className="w-10 h-10 mx-auto text-primary mb-3" />
          <h2 className="text-2xl font-bold">{title || 'Horaires d\'ouverture'}</h2>
        </div>

        <div className="bg-white rounded-xl shadow-sm border divide-y">
          {schedule.map((item, index) => (
            <div
              key={index}
              className={`flex justify-between items-center px-4 py-3 ${
                index === todayIndex ? 'bg-primary/5' : ''
              }`}
            >
              <span className={`font-medium ${index === todayIndex ? 'text-primary' : ''}`}>
                {item.day}
                {index === todayIndex && (
                  <span className="ml-2 text-xs bg-primary text-white px-2 py-0.5 rounded-full">
                    Aujourd'hui
                  </span>
                )}
              </span>
              <span className={item.closed ? 'text-red-500' : 'text-muted-foreground'}>
                {item.closed ? 'Fermé' : `${item.open} - ${item.close}`}
              </span>
            </div>
          ))}
        </div>

        {note && (
          <p className="text-center text-sm text-muted-foreground mt-4">
            {note}
          </p>
        )}
      </div>
    </section>
  );
}
